module.exports = __webpack_public_path__ + "static/img/work_list_no_data.2ae908fa.png";